import React from 'react'
import { Spin as AntSpin } from 'antd'
import { SpinProps as AntSpinProps } from 'antd/lib/spin'

type Props = AntSpinProps

export const Spin: React.FC<Props> = ({
  children,
  className,
  delay,
  size,
  spinning,
  indicator,
  wrapperClassName
}) => {
  return (
    <AntSpin
      className={className}
      delay={delay}
      size={size}
      spinning={spinning}
      indicator={indicator}
      wrapperClassName={wrapperClassName}
    >
      {children}
    </AntSpin>
  )
}
